import { createFeature, createReducer, on } from '@ngrx/store'
import { EmployeeRequestState } from './employee-request.state'
import {
  createEmployeeRequest,
  createEmployeeRequestFailure,
  createEmployeeRequestsSuccess,
  loadEmployeeRequests,
  loadEmployeeRequestsFailure,
  loadEmployeeRequestsSuccess,
  updateEmployeeRequest,
  updateEmployeeRequestFailure,
  updateEmployeeRequestsSuccess
} from './employee-request.actions'

export const initialState: EmployeeRequestState = {
  totalCount: 0,
  empRequests: [],
  loading: false,
  error: null
}

// Create the Employee request reducer
export const employeeRequestReducer = createReducer(
  initialState,
  on(loadEmployeeRequests, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(loadEmployeeRequestsSuccess, (state, { totalCount, empRequests }) => ({
    ...state,
    totalCount,
    empRequests,
    loading: false,
    error: null
  })),
  on(loadEmployeeRequestsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(createEmployeeRequest, state => ({ ...state, loading: true })),
  on(createEmployeeRequestsSuccess, (state, { empRequest }) => ({
    ...state,
    empRequests: [...state.empRequests, empRequest],
    loading: false,
    totalCount: state.totalCount + 1
  })),
  on(createEmployeeRequestFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(updateEmployeeRequest, state => ({ ...state, loading: true })),
  on(updateEmployeeRequestsSuccess, (state, { empRequest }) => ({
    ...state,
    empRequests: [...state.empRequests, empRequest],
    loading: false
  })),
  on(updateEmployeeRequestFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  }))
)

// Create the feature for the Designation state
export const employeeRequestFeature = createFeature({
  name: 'employeeRequest', // Feature name
  reducer: employeeRequestReducer
})
export type { EmployeeRequestState }
// Export the feature's selectors
export const { name, reducer, selectEmpRequests, selectLoading, selectError, selectTotalCount } =
  employeeRequestFeature
